module.exports = __webpack_public_path__ + "static/media/stop-dropoff.27ed703b.svg";